var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video-player',{staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }